import { merge } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { EventGroups } from '../../../constants';
import { createBaseEvent } from '../../base';
import { ACTION_TYPE, DEFAULT_SOURCE_INFO } from './constants';

export const createBaseUserActionEvent = (type, { targetLocale, sourceInfo: { gig, user, ...page } }) => {
    const { pageCtxId } = getContext();

    return createBaseEvent({
        type,
        group: EventGroups.userActions,
        user: merge({}, user, {
            locale: targetLocale,
        }),
        gig,
        action: {
            type: ACTION_TYPE,
        },
        page: merge(DEFAULT_SOURCE_INFO, { ctx_id: pageCtxId }, page),
    });
};
